// extracted by mini-css-extract-plugin
export default {"terms":"terms___t36iD","checkout":"checkout___PxcX0","buy_button":"buy_button___jA1gu","tab_title":"tab_title___FupxP","disabled_warn":"disabled_warn___oLkfw"};